import type { SVGProps } from 'react';

interface ThumbDownIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const ThumbDownIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & ThumbDownIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 12 12"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M9.143 0H3.429v7.8l4 4.2.714-.75a.8.8 0 0 0 .164-.285q.064-.18.064-.345v-.21L7.743 7.8h3.114q.458 0 .8-.36Q12 7.08 12 6.6V5.4a1.3 1.3 0 0 0-.086-.45L10.2.72q-.129-.3-.429-.51T9.143 0M2.286 7.8V0H0v7.8z"
      fill="#F73A11"
    />
  </svg>
);
